import React, { useEffect, useState } from "react";
import { FiBookmark } from "react-icons/fi";
import AppShell from "../components/layout/AppShell";
import PostCard from "../components/common/PostCard";
import { EmptyState, CardSkeleton, Button } from "../components/ui";
import { getMyFavoritePosts } from "../api/posts";
import useUsersMap from "../hooks/useUsersMap";
import { Link } from "react-router-dom";

export default function SavedPosts() {
  const { usersById } = useUsersMap();
  const [posts, setPosts] = useState([]);
  const [postIds, setPostIds] = useState(new Set());
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    getMyFavoritePosts()
      .then(res => { setPosts(res.data?.posts || []); setPostIds(new Set(res.data?.postIds || [])); })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  const handleDeleted = (postId) => {
    setPosts((prev) => prev.filter((p) => p.id !== postId));
  };

  useEffect(load, []);

  return (
    <AppShell title="Saved posts" subtitle="Your bookmarked innovations">
      {loading ? (
        <div className="space-y-4"><CardSkeleton /><CardSkeleton /></div>
      ) : posts.length === 0 ? (
        <EmptyState
          icon={<FiBookmark className="h-6 w-6" />}
          title="No saved posts yet"
          description="When you bookmark a post, it will appear here for easy access."
          action={<Link to="/dashboard"><Button>Browse the feed</Button></Link>}
        />
      ) : (
        <div className="space-y-4">
          {posts.map(post => (
            <PostCard key={post.id} post={post} author={usersById[post.userId]} isFavorited={postIds.has(post.id)} onDeleted={handleDeleted} />
          ))}
        </div>
      )}
    </AppShell>
  );
}
